<template>
  <section @wheel="onWheel" class="list-games" ref="listGames">
    <template
        v-for="game of games"
        :key="game.storeId"
    >
      <Card
          :game="game"
          :storeRank="game.index + 1"
      />
    </template>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/components/Game/Card';

export default {
  name: 'ListGames',
  components: {
    Card,
  },
  props: ['games'],
  computed: {
    ...mapGetters({
      isLoading: 'game/isLoading',
    }),
  },
  methods: {
    /**
     * On larger screens, with column display, vertical wheel event will
     * trigger a horizontal scroll
     * @param e
     */
    onWheel(e) {
      if (window.getComputedStyle(this.$refs.listGames).flexDirection === 'column' && Math.abs(e.deltaX) === 0 && e.deltaY !== 0) {
        e.preventDefault();
        this.$refs.listGames.scrollLeft += e.deltaY * 5;
      }
    },
  },
};
</script>

<style lang="scss">
@use '@/assets/common.scss' as *;

.list-games {
  border-top: 1px solid #ebeef5;
  @media #{$media-large-screen} {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-x: auto;
    flex: 1;
    border-top: none;
  }
}
</style>
